var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.root
    ? _c(
        "div",
        [
          _c(
            "ul",
            {
              staticClass: "cw-tiles"
            },
            _vm._l(_vm.filteredChildren, function(child) {
              return _c(
                "li",
                {
                  key: child.id,
                  staticClass: "tile",
                  class: [
                    child.attributes.payload.color,
                    _vm.filteredChildren.length > 3 ? "" : "cw-tile-margin"
                  ]
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.getElementUrl(child.id),
                        title: child.attributes.title
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "preview-image",
                        class: [_vm.hasImage(child) ? "" : "default-image"],
                        style: _vm.getChildStyle(child)
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "description"
                        },
                        [
                          _c(
                            "header",
                            {
                              class: [
                                child.attributes.purpose !== ""
                                  ? "description-icon-" +
                                    child.attributes.purpose
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(child.attributes.title) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "description-text-wrapper"
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(child.attributes.payload.description)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "footer",
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.countChildren(child) + 1) +
                                  "\n                        "
                              ),
                              _c(
                                "translate",
                                {
                                  attrs: {
                                    "translate-n": _vm.countChildren(child) + 1,
                                    "translate-plural": "Seiten"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            Seite\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.children.length !== 0 &&
          _vm.filteredChildren.length === 0 &&
          _vm.purposeFilter !== "all"
            ? _c("courseware-companion-box", {
                attrs: {
                  msgCompanion: _vm.text.emptyFilter,
                  mood: "pointing"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.children.length === 0
            ? _c(
                "div",
                {
                  staticClass: "cw-contents-overview-teaser"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cw-contents-overview-teaser-content"
                    },
                    [
                      _c(
                        "header",
                        [
                          _c("translate", [
                            _vm._v("Ihre persönlichen Lernmaterialien")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        [
                          _c("translate", [
                            _vm._v(
                              "Erstellen und Verwalten Sie hier ihre eigenen persönlichen Lernmaterialien in Form von ePorfolios,\n                        Vorlagen für Veranstaltungen oder einfach nur persönliche Inhalte für das Studium.\n                        Entwickeln Sie ihre eigenen (Lehr-)Materialien für Studium oder die Lehre und teilen diese mit anderen Nutzenden."
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          on: {
                            click: _vm.addElement
                          }
                        },
                        [
                          _c("translate", [
                            _vm._v("Neues Lernmaterial anlegen")
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showOverviewElementAddDialog
            ? _c("studip-dialog", {
                staticClass: "cw-structural-element-dialog",
                attrs: {
                  title: _vm.$gettext("Neues Lernmaterial anlegen"),
                  height: "600",
                  width: "500",
                  confirmText: _vm.$gettext("Erstellen"),
                  confirmClass: "accept",
                  closeText: _vm.$gettext("Schließen"),
                  closeClass: "cancel"
                },
                on: {
                  close: _vm.closeAddDialog,
                  confirm: _vm.createElement
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "dialogContent",
                      fn: function fn() {
                        return [
                          _c(
                            "courseware-collapsible-box",
                            {
                              attrs: {
                                title: _vm.$gettext("Grundeinstellungen"),
                                open: true
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [
                                        _vm._v("Titel des Lernmaterials")
                                      ]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.newElement.attributes.title,
                                            expression:
                                              "newElement.attributes.title"
                                          }
                                        ],
                                        attrs: {
                                          type: "text"
                                        },
                                        domProps: {
                                          value: _vm.newElement.attributes.title
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) {
                                              return
                                            }

                                            _vm.$set(
                                              _vm.newElement.attributes,
                                              "title",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [
                                        _vm._v("Zusammenfassung")
                                      ]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.newElement.attributes.payload
                                                .description,
                                            expression:
                                              "newElement.attributes.payload.description"
                                          }
                                        ],
                                        domProps: {
                                          value:
                                            _vm.newElement.attributes.payload
                                              .description
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) {
                                              return
                                            }

                                            _vm.$set(
                                              _vm.newElement.attributes.payload,
                                              "description",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [_vm._v("Bild")]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("input", {
                                        ref: "upload_image",
                                        attrs: {
                                          type: "file",
                                          accept: "image/*"
                                        },
                                        on: {
                                          change: _vm.checkUploadFile
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.uploadFileError
                                        ? _c("courseware-companion-box", {
                                            staticClass:
                                              "cw-companion-box-in-form",
                                            attrs: {
                                              msgCompanion: _vm.uploadFileError,
                                              mood: "sad"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [
                                        _vm._v("Art des Lernmaterials")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.newElementPurpose,
                                              expression: "newElementPurpose"
                                            }
                                          ],
                                          on: {
                                            change: function change($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.newElementPurpose = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "content"
                                              }
                                            },
                                            [
                                              _c("translate", [
                                                _vm._v("Inhalt")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "template"
                                              }
                                            },
                                            [
                                              _c("translate", [
                                                _vm._v("Aufgabenvorlage")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "oer"
                                              }
                                            },
                                            [
                                              _c("translate", [
                                                _vm._v("OER-Material")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "portfolio"
                                              }
                                            },
                                            [
                                              _c("translate", [
                                                _vm._v("ePortfolio")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "draft"
                                              }
                                            },
                                            [
                                              _c("translate", [
                                                _vm._v("Entwurf")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "other"
                                              }
                                            },
                                            [
                                              _c("translate", [
                                                _vm._v("Sonstiges")
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [
                                        _vm._v("Lernmaterialvorlage")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.newElementTemplate,
                                              expression: "newElementTemplate"
                                            }
                                          ],
                                          on: {
                                            change: function change($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.newElementTemplate = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: null
                                              }
                                            },
                                            [
                                              _c("translate", [
                                                _vm._v("ohne Vorlage")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.selectableTemplates,
                                            function(template) {
                                              return _c(
                                                "option",
                                                {
                                                  key: template.id,
                                                  domProps: {
                                                    value: template
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        template.attributes.name
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-collapsible-box",
                            {
                              attrs: {
                                title: _vm.$gettext("Vorschau")
                              }
                            },
                            [
                              _vm.currentTemplateStructure
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "cw-template-preview"
                                    },
                                    _vm._l(
                                      _vm.currentTemplateStructure.containers,
                                      function(container) {
                                        return _c(
                                          "div",
                                          {
                                            key: container.id,
                                            staticClass:
                                              "cw-template-preview-container-wrapper",
                                            class: [
                                              "cw-template-preview-container-" +
                                                container.attributes.payload
                                                  .colspan
                                            ]
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cw-template-preview-container-content"
                                              },
                                              [
                                                _c(
                                                  "header",
                                                  {
                                                    staticClass:
                                                      "cw-template-preview-container-title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          container.attributes
                                                            .title
                                                        ) +
                                                        " | " +
                                                        _vm._s(
                                                          container.attributes
                                                            .width
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  container.blocks,
                                                  function(block) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: block.id,
                                                        staticClass:
                                                          "cw-template-preview-blocks"
                                                      },
                                                      [
                                                        _c(
                                                          "header",
                                                          {
                                                            staticClass:
                                                              "cw-template-preview-blocks-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  block
                                                                    .attributes
                                                                    .title
                                                                ) +
                                                                "\n                                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("courseware-companion-box", {
                                    attrs: {
                                      msgCompanion: _vm.$gettext(
                                        "Sie können eine Lernmaterialvorlage auswählen und hier eine Vorschau betrachten. Ohne Vorlage wird eine leere Seite erzeugt."
                                      )
                                    }
                                  })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-collapsible-box",
                            {
                              attrs: {
                                title: _vm.$gettext("Zusatzangaben")
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [_vm._v("Lizenztyp")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.newElement.attributes
                                                  .payload.license_type,
                                              expression:
                                                "newElement.attributes.payload.license_type"
                                            }
                                          ],
                                          on: {
                                            change: function change($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })

                                              _vm.$set(
                                                _vm.newElement.attributes
                                                  .payload,
                                                "license_type",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(_vm.licenses, function(license) {
                                          return _c(
                                            "option",
                                            {
                                              key: license.id,
                                              domProps: {
                                                value: license.id
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(license.name) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [
                                        _vm._v("Geschätzter zeitlicher Aufwand")
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.newElement.attributes.payload
                                                .required_time,
                                            expression:
                                              "newElement.attributes.payload.required_time"
                                          }
                                        ],
                                        attrs: {
                                          type: "text"
                                        },
                                        domProps: {
                                          value:
                                            _vm.newElement.attributes.payload
                                              .required_time
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) {
                                              return
                                            }

                                            _vm.$set(
                                              _vm.newElement.attributes.payload,
                                              "required_time",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [_vm._v("Niveau")]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("translate", [_vm._v("von")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.newElement.attributes
                                                  .payload.difficulty_start,
                                              expression:
                                                "newElement.attributes.payload.difficulty_start"
                                            }
                                          ],
                                          on: {
                                            change: function change($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })

                                              _vm.$set(
                                                _vm.newElement.attributes
                                                  .payload,
                                                "difficulty_start",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(12, function(difficulty_start) {
                                          return _c(
                                            "option",
                                            {
                                              key: difficulty_start,
                                              domProps: {
                                                value: difficulty_start
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(difficulty_start) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("translate", [_vm._v("bis")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.newElement.attributes
                                                  .payload.difficulty_end,
                                              expression:
                                                "newElement.attributes.payload.difficulty_end"
                                            }
                                          ],
                                          on: {
                                            change: function change($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })

                                              _vm.$set(
                                                _vm.newElement.attributes
                                                  .payload,
                                                "difficulty_end",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(12, function(difficulty_end) {
                                          return _c(
                                            "option",
                                            {
                                              key: difficulty_end,
                                              domProps: {
                                                value: difficulty_end
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(difficulty_end) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("translate", [_vm._v("Farbe")]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          options: _vm.colors,
                                          reduce: function reduce(color) {
                                            return color.class
                                          },
                                          label: "class"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "open-indicator",
                                              fn: function fn(
                                                selectAttributes
                                              ) {
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._b(
                                                      {},
                                                      "span",
                                                      selectAttributes,
                                                      false
                                                    ),
                                                    [
                                                      _c("studip-icon", {
                                                        attrs: {
                                                          shape: "arr_1down",
                                                          size: "10"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "no-options",
                                              fn: function fn(_ref) {
                                                var search = _ref.search,
                                                  searching = _ref.searching,
                                                  loading = _ref.loading
                                                return [
                                                  _c("translate", [
                                                    _vm._v(
                                                      "Es steht keine Auswahl zur Verfügung."
                                                    )
                                                  ])
                                                ]
                                              }
                                            },
                                            {
                                              key: "selected-option",
                                              fn: function fn(_ref2) {
                                                var name = _ref2.name,
                                                  hex = _ref2.hex
                                                return [
                                                  _c("span", {
                                                    staticClass:
                                                      "vs__option-color",
                                                    style: {
                                                      "background-color": hex
                                                    }
                                                  }),
                                                  _c("span", [
                                                    _vm._v(_vm._s(name))
                                                  ])
                                                ]
                                              }
                                            },
                                            {
                                              key: "option",
                                              fn: function fn(_ref3) {
                                                var name = _ref3.name,
                                                  hex = _ref3.hex
                                                return [
                                                  _c("span", {
                                                    staticClass:
                                                      "vs__option-color",
                                                    style: {
                                                      "background-color": hex
                                                    }
                                                  }),
                                                  _c("span", [
                                                    _vm._v(_vm._s(name))
                                                  ])
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2373101287
                                        ),
                                        model: {
                                          value:
                                            _vm.newElement.attributes.payload
                                              .color,
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.newElement.attributes.payload,
                                              "color",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "newElement.attributes.payload.color"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1425382597
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("courseware-companion-overlay")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }